(ns hypnos.backoffice.tile.consults
  "Consults tile."
  (:require [hypnos.backoffice.core.auth :as auth]
            [hypnos.backoffice.subs]
            [hypnos.backoffice.tile.table.consult-details :as consult-details]
            [hypnos.backoffice.tile.table.consults :as consults]
            [hypnos.graphql.mutations :as mutations]
            [hypnos.i18n :refer [tr]]
            [hypnos.lookup :refer (lookup-make-by-id lookup-mask-by-model-id)]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- load
  [body]
  (if-let [_loading? @(rf/subscribe [:backoffice/gql-request-in-progress?])]
    [:div.card-content
     [:section.section
      [:div.content.has-text-grey.has-text-centered
       [:p
        [:span.icon.is-large
         [:i.mdi.mdi-loading.mdi-48px.mdi-spin]]]
       [:p (tr :ui.label/loading)]]]]
    body))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

(defn consults-tile
  "The consults list tile."
  [consult-states]
  [consults/table consult-states])

(defn prior-consults-tile
  "The (prior) consults for the patient tile."
  [state]
  (let [auth    (rf/subscribe [:backoffice/auth])
        catalog (rf/subscribe [:backoffice/catalog])
        patient (rf/subscribe [:backoffice/patient])]
    [:div.tile.is-ancestor
     [:div.tile.is-parent
      [:div.card.tile.is-child
       [:header.header.card-header
        [:p.card-header-title (tr :ui.label/consults)]
        (when (and (auth/authorized? @auth :send-message)
                   (= :consult-state/completed (get-in @state [:patient :patient/last-consult :consult/status :value])))
          (let [model-id (get-in @state [:patient :patient/last-consult :consult/model :value])
                ids      (lookup-mask-by-model-id @catalog model-id)
                make     (lookup-make-by-id @catalog (:manufacturer/id ids) (:make/id ids))]
            [:button.button.is-small.is-success
             {:disabled (nil? (:make/fit-guide make))
              :on-click (fn [_]
                          (let [consult-id (get-in @state [:patient :patient/last-consult :consult/id :value])]
                            (when (and consult-id (:make/fit-guide make))
                              (rf/dispatch [:amplify/mutation
                                            mutations/send-communication
                                            {:consult_id            (str consult-id)
                                             :communication_channel "sms"
                                             :communication_type    "fit_guide"}
                                            :backoffice/refresh-patient]))))}
             [:span.icon.is-small [:i.mdi.mdi-youtube]]
             [:span (tr :ui.label/send-fit-guide)]]))]
       (load
        [:div.card-content
         [consult-details/table @patient]])]]]))
